import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    {
      num: '01',
      icon: 'ri-search-line',
      title: t('howItWorks.step1Title'),
      desc: t('howItWorks.step1Desc'),
    },
    {
      num: '02',
      icon: 'ri-file-info-line',
      title: t('howItWorks.step2Title'),
      desc: t('howItWorks.step2Desc'),
    },
    {
      num: '03',
      icon: 'ri-shopping-cart-line',
      title: t('howItWorks.step3Title'),
      desc: t('howItWorks.step3Desc'),
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 text-center mb-14">
          {t('howItWorks.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {steps.map((step, i) => (
            <div key={i} className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-5 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${step.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-accent-200 mb-3">
                {step.num}
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs mx-auto">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}